/**
 * Generic modal
 * @method setAlertModal
 * @method setLoadingModal
 * Campaign modal
 * @method setCampaignModal
 * @method setAddToCartModal
 */
export function ModalController () {
    //generic
    this.alertModal = null;
    this.loadingModal = null;
    this.campaignModal = null;
    this.addToCartModal = null;

    //#region generic
    this.setAlertModal = function(alertModalController) {
        this.alertModal = alertModalController;
    };
    this.setLoadingModal = function(loadingModalController) {
        this.loadingModal = loadingModalController;
    };
    //#endregion generic
    this.setCampaignModal = function(CampaignModalController) {
        this.campaignModal = CampaignModalController;
    };
    this.setAddToCartModal = function(AddToCartModalController) {
        this.addToCartModal = AddToCartModalController;
    };


}
